import DisabledByDefaultIcon from '@mui/icons-material/DisabledByDefault'
import { Box, Typography, Stack } from '@mui/material'
import type React from 'react'

interface Props {
  title: string
  subtitle: string
}

const DrawerTitle: React.FC<Props> = ({ title, subtitle }) => (
  <Box sx={{ mb: 3 }}>
    <Stack direction="row" spacing={1} alignItems="center">
      <DisabledByDefaultIcon sx={{ color: '#1B4554' }} />
      <Typography variant="h5" fontWeight={600}>
        {title}
      </Typography>
    </Stack>
    <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
      {subtitle}
    </Typography>
  </Box>
)

export default DrawerTitle
